import { ButtonProps } from "../../types";
import styles from "./Button.module.css";
import useWindowDimensions from "./useWindowDimensions";
import { useScrollbarWidth } from "./useScrollbarWidth";

const Button = ({ selectedTab, tab, onTabChange, text }: ButtonProps) => {
  const { width } = useWindowDimensions();
  const scrollbarWidth = useScrollbarWidth();
  const imageWidth =
    width < 768 ? width / 2 - 40 : (width - scrollbarWidth - 8 * 10) / 8;
  return (
    <div className={styles.wrapper} onClick={() => onTabChange(tab)}>
      <img
        src={
          tab !== selectedTab
            ? "media/002_Button.png"
            : "media/003_Button_Rot.png"
        }
        alt={"Button"}
        width={imageWidth}
      />
      <div className={styles.buttonText} style={{}}>
        {text}
      </div>
    </div>
  );
};

export default Button;
